import React from "react";

interface IconProps {
  color?: string;
  size?: number;
}

const Funil: React.FC<IconProps> = ({ color = "#09090B", size = 32 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.66667 13.3333V10.276L13.6093 5.33333C13.8593 5.08333 14 4.744 14 4.39V2.66667C14 2.48986 13.9298 2.32029 13.8047 2.19526C13.6797 2.07024 13.5101 2 13.3333 2H2.66667C2.48986 2 2.32029 2.07024 2.19526 2.19526C2.07024 2.32029 2 2.48986 2 2.66667V4.39C2 4.744 2.14067 5.08333 2.39067 5.33333L7.33333 10.276V14.6667L8.66667 13.3333Z"
      fill={color}
    />
  </svg>
);

export default Funil;
